<template>
  <v-card class="box-container ma-0 pa-0" style="width: 100%; height: 100%; overflow: hidden" fluid fill-height>
    <loading
      :can-cancel="cancelProg"
      :on-cancel="
        () => {
          isLoading = false;
        }
      "
      :background-color="$vuetify.theme.dark ? '#000' : '#FFF'"
      :color="$vuetify.theme.dark ? '#FFF' : '#000'"
      loader="bars"
      :active.sync="isLoading"
      :opacity="0.9"
    >
      <span slot="after">
        <br />
        {{ "Програмиране на департамент " + loaderValue + " от " + departmentsCountMax }}
      </span>
    </loading>
    <v-dialog v-if="dialogReport" v-model="dialogReport" :overlay-opacity="0.92" persistent max-width="320" style="z-index: 9999999">
      <v-card>
        <v-card-title>Ненулев дневен отчет</v-card-title>
        <v-card-actions class="mx-4">
          <span>Преди да програмирате артикулите е необходимо да направите дневен финансов отчет с нулиране.</span>
        </v-card-actions>
        <v-card-actions class="mx-4" v-if="!isOnMobile">
          <span>Желаете ли да направите отчета?</span>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogReport = false" color="warning" tile>Отказ</v-btn>
          <v-btn @click="printDailyReport()" color="success" tile>ОК</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="row-header ma-0 pa-0" ref="refHeaders">
      <v-row class="ma-0 pl-3 pb-1" justify="center" align="center">
        <v-spacer></v-spacer>
        <span class="title">
          <b>Програмиране на департаменти</b>
        </span>
        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="closeProgArt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider class="ma-0 pa-0"></v-divider>
      <v-row class="ma-0 pa-0" align="center" justify="center">
        <v-col cols="10" class="pa-0 ma-0">
          <v-row class="ma-0 pa-0" justify="space-between">
            <v-text-field ca @input="fixName(searchText)" v-model="searchText" outlined label="Търсене" dense></v-text-field>
            <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="callProgDep" :disabled="selected.length == 0">
              <v-icon color="#1685c9" left>mdi-content-save</v-icon>
              <span>Запази</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-form class="row-content ma-0 pa-0" v-on:submit.prevent lazy-validation ref="refVirtualScrollerContainer">
      <v-virtual-scroll ref="refVirtualScroller" :items="searchPlu" :item-height="75" :width="virtualScrollerWidth" :height="virtualScrollerHeight" id="progVirtualScroll">
        <template v-slot="{ item }">
          <v-list-item :key="item.DepNum" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" align="center" justify="center">
              <v-col cols="2" class="ma-0 pa-1">
                <v-text-field @focus="$event.target.select()" :value="`${item.DepNum}`" label="№" dense outlined class="ma-0 pa-0 centered-input" disabled></v-text-field>
              </v-col>
              <v-col cols="6" class="ma-0 pa-1">
                <v-text-field @focus="$event.target.select()" :rules="depName_Rule" @input="fixName(item), shoveInForProgramming(item)" label="Име" class="ma-0 pa-0" dense outlined v-model="item.DepName" />
              </v-col>
              <v-col cols="2" class="ma-0 pa-1">
                <v-select @input="shoveInForProgramming(item)" label="Дан. гр." dense outlined :items="returnVAT_groups" v-model="item.OptionVATClass" class="ma-0 pa-0"></v-select>
              </v-col>
            </v-row>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-form>
  </v-card>
</template>

<script>
import Const from "../constants.js";
import Tremol from "../assets/fp/fp";
import Loading from "vue-loading-overlay";
// import JSZip from "jszip";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      virtualScrollerWidth: "100%",
      virtualScrollerHeight: "100%",
      intervalRecalcSize: null,
      dialogReport: false,
      cancelProg: false,
      searchText: "",
      isLoading: false,
      selected: [],
      departments: [],
      loaderValue: 0,
      departmentsCountMax: 41,
      depName_Rule: [
        (v) => {
          if (v || v === 0) {
            return true;
          } else {
            return "Задължително поле";
          }
        },
        (v) => v.length <= 20 || "Името не може да бъде повече от 20 символа!",
      ],
    };
  },

  computed: {
    departmentCountMax() {
      return this.selected.length;
    },
    searchPlu() {
      if (this.searchText == "") {
        return this.departments;
      } else {
        return this.departments.filter((dep) => {
          return dep.PLUName.toLowerCase().includes(this.searchText.toLowerCase()) || dep.Price.toString().includes(this.searchText.toString().toLowerCase()) || dep.Barcode.toString().includes(this.searchText.toString().toLowerCase());
        });
      }
    },
    returnVAT_groups() {
      let vats = Object.values(Tremol.Enums.OptionVATClass);
      const index = vats.indexOf("*");
      if (index > -1) vats.splice(index, 1);
      vats.length = 4;
      return vats;
    },
  },
  methods: {
    fixName(item) {
      if (item.DepName && item.DepName.indexOf("@") > -1) {
        item.DepName = item.DepName.split("@").join(" ");
      }
    },
    shoveInForProgramming(dep) {
      let dep_Original = this.fp.departments.find((d) => d.DepNum == dep.DepNum);
      if (typeof plu_Original === "undefined") {
        if (this.selected.indexOf(dep) == -1) {
          this.selected.push(dep);
        }
      } else {
        if (dep_Original.DepName != dep.DepName || dep_Original.OptionVATClass != dep.OptionVATClass) {
          if (this.selected.indexOf(dep) == -1) {
            this.selected.push(dep);
          }
        }
      }
    },
    async callProgDep() {
      try {
        if (this.$refs.refVirtualScrollerContainer.validate()) {
          this.loaderValue = 0;
          this.isLoading = true;
          await this.progDep();
        } else {
          throw new Error("Намерен департамент с невалидни данни!");
        }
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    async progDep() {
      //   await this.fp.executeWithLoader(async () => {
      try {
        if (this.cancelProg) {
          this.loaderValue = 0;
          this.cancelProg = false;
          return;
        }
        let depToProgram = this.selected[this.loaderValue];
        if (this.loaderValue >= this.selected.length || this.loaderValue >= this.fp.maxSupportedDeps) {
          this.selected.forEach((dep) => {
            dep.isVisible = true;
            let index = this.fp.departments.indexOf(this.fp.departments.find((d) => d.DepNum == dep.DepNum));
            if (index != -1) {
              this.$set(this.fp.departments, index, dep);
            } else {
              throw new Error("Невалиден номер на департамент?!");
              //this.fp.departments.push(Object.assign({}, dep));
            }
          });
          this.fp.setInfoMessage("Успешно програмиране на департаменти.");

          this.selected = [];

          this.loaderValue = 0;
          this.isLoading = false;
          this.refreshDepartments();
        } else {
          let dep_Original = this.fp.departments.find((plu) => plu.PLUNum == depToProgram.PLUNum);

          if (typeof dep_Original === "undefined" || depToProgram.DepName != dep_Original.DepName || depToProgram.OptionVATClass != dep_Original.OptionVATClass) {
            await this.fp.ProgDepartment(depToProgram.DepNum, depToProgram.DepName, depToProgram.OptionVATClass);
          }
          this.loaderValue++;
          await this.progDep();
        }
      } catch (ex) {
        // this.selected = [];
        this.loaderValue = 0;
        this.isLoading = false;
        if (ex instanceof Tremol.ServerError) {
          if (ex.isFpException && ex.ste2 === 0x33) {
            this.dialogReport = true;
          } else {
            this.fp.handleException(ex);
          }
        }
      }
      // });
    },
    closeProgArt() {
      this.fp.exitMode(Const.Modes.ProgramDepartments);
    },
    async printDailyReport() {
      await this.fp.executeWithLoader(async () => {
        try {
          await this.fp.PrintDailyReport(Tremol.Enums.OptionZeroing.Zeroing);
        } catch (ex) {
          this.fp.handleException(ex);
        }
        this.dialogReport = false;
      });
    },
    refreshDepartments() {
      this.departments = [];
      for (var i = 1; i <= this.fp.maxSupportedDeps; i++) {
        this.departments.push(Object.assign({}, this.fp.departments[i]));
      }
    },
    recalcWidthHeight() {
      if (this.intervalRecalcSize) clearInterval(this.intervalRecalcSize);
      this.intervalRecalcSize = setTimeout(() => {
        if (!this.$refs.refVirtualScrollerContainer) return;
        this.virtualScrollerWidth = this.$refs.refVirtualScrollerContainer.clientWidth;
        this.virtualScrollerHeight = window.innerHeight - this.$refs.refHeaders.clientHeight;
        //this.virtualScrollerHeight = this.$refs.refVirtualScrollerContainer.clientHeight;
        //if (this.virtualScrollerHeight > this.deviceHeight * this.getDevices.length) this.virtualScrollerHeight = this.deviceHeight * this.getDevices.length;
      }, 333);
    },
  },
  mounted() {
    this.recalcWidthHeight();
    this.refreshDepartments();
    window.addEventListener("resize", this.recalcWidthHeight);
  },
  updated() {
    this.recalcWidthHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcWidthHeight);
  },
};
</script>

<style>
.v-select-list .v-list-item .v-list-item__content .v-list-item__title .v-select__selections {
  text-align: center;
}
</style>